import React from 'react';
// import { loadReCaptcha, ReCaptcha } from 'react-recaptcha-v3'
import ReCAPTCHA from "react-google-recaptcha";
import { v4 as uuidv4 } from 'uuid';
import './uber2.css';
// import UberLogo from '../uber-assets/UElogo.svg';
import { AREAS, AREAS_OBJ, AREA_IDS, VOTE_AREAS_BUTTON_ORDER } from './model/areas';
import ApiController from './controller/ApiController';
import { SHORTLIST } from './model/shortlist';
import NominatePage from './nominate-page';

/**
 * @author Carl Trelfa
 */

const NOMINEES_PER_ROW = 4;
const NOMINEES_PER_ROW_840 = 3;
const NOMINEES_PER_ROW_576 = 2;
const NOMS_END_TIME = 1689894000; // 1689894000 midnight 20/21-07-2023 // 1689852600 // Test time: 1689852613 (20/07/2023, 12:30) // June 2030: 1908972688 (keep in nominations ended until we update it basically) // way in the past: 0 // old proper live time: 1652050860; // fake live time: 1651737600; Proper live time: 1652050860
const LIVE_TIME = 1689894000 // June 2030: 1908972688 (keep in nominations ended until we update it basically) // way in the past: 0 // old proper live time: 1652050860; // fake live time: 1651737600; Proper live time: 1652050860
const VOTE_END_TIME = 1692486060 // Sun Aug 20 2023 00:00:01 GMT+0100 (British Summer Time) // 1908982688 // > June 2030: 1908982688 // way in the future: 9999999999 // old proper vote end time: 1655366400; // 1655213400 = 14:30, 14 June; 1655215200 = 15:00, 14 June; 1655366400 = 9am 16th June (proper vote end time)

const RECAPTCHA_STATE = {
    LOADING: 'loading',
    READY: 'ready',
    VERIFIED: 'verified',
}

export default class VotePage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            reacaptchaState: RECAPTCHA_STATE.LOADING,
            recaptchaToken: null,
            showRecaptcha: false,
            lastVote: null,

            guid: null,
            currentArea: 'all',
            currentAreaIndex: 0,
            //  a couple of dummy votes to show the check mark
            currentVotes: [],
            regionNominees: [],
            nomineesPerRow: NOMINEES_PER_ROW,
            showDropdown: false,
            shortlistFetched: true,
            shortList: SHORTLIST,
            live: false,
            nomsEnded: false,
            timeToLive: 0,
            votingEnded: false,
            timeToVoteEnd: 0,
        }
    }

    storageAvailable(type = "localStorage") {
        let storage;
        try {
          storage = window[type];
          const x = "__storage_test__";
          storage.setItem(x, x);
          storage.removeItem(x);
          return true;
        } catch (e) {
          return (
            e instanceof DOMException &&
            // everything except Firefox
            (e.code === 22 ||
              // Firefox
              e.code === 1014 ||
              // test name field too, because code might not be present
              // everything except Firefox
              e.name === "QuotaExceededError" ||
              // Firefox
              e.name === "NS_ERROR_DOM_QUOTA_REACHED") &&
            // acknowledge QuotaExceededError only if there's something already stored
            storage &&
            storage.length !== 0
          );
        }
      }

    componentDidMount() {
        let uuid = uuidv4();
        // console.log('generated uuid: ', uuid);

        /* // if we have one in a cookie, use that...
        let allcookies = document.cookie;
        // console.log(allcookies);
        let cookiearray = allcookies.split(';');
        for (let i = 0; i < cookiearray.length; i++) {
            // console.log('cookie[i]: ', i, cookiearray[i]);
            let name = cookiearray[i].split('=')[0];
            let value = cookiearray[i].split('=')[1];
            if (name && value) {
                name = name.replace(' ', '');
                value = value.replace(' ', '');
                // console.log(name, value);
                if (name === 'guid') {
                    uuid = value;
                }
                if (name === 'votes') {
                    this.setState({ currentVotes: value.split(',') });
                }
            }
        }
        document.cookie = 'guid = ' + uuid; */

        let guid = this.storageAvailable() ? localStorage.getItem('guid') : null;
        if (guid) {
            uuid = guid;
        }
        if (this.storageAvailable()) {
            localStorage.setItem('guid', uuid);
        }

        let storedVotes = this.storageAvailable() ? localStorage.getItem('votes') : null;
        if (storedVotes) {
            // console.log('Got stored votes: ', storedVotes);
            const votesSplit = storedVotes.split(',');
            for (let i = 0; i < votesSplit.length; i++) {
                votesSplit[i] = Number(votesSplit[i]);
            }
            this.setState({ currentVotes: votesSplit });
        }

        let time = Math.floor(Date.now() / 1000);

        let live = false;
        let timeToLive = 0;
        if (time > LIVE_TIME) {
            live = true;
        } else {
            live = false;
            timeToLive = LIVE_TIME - time;
        }

        let votingEnded = false;
        let timeToVoteEnd = 0;
        if (time > VOTE_END_TIME) {
            votingEnded = true;
        } else {
            votingEnded = false;
            timeToVoteEnd = VOTE_END_TIME - time;
        }

        let nomsEnded = false;
        if (time > NOMS_END_TIME) {
            nomsEnded = true;
        }

        if (!live || !votingEnded) {
            setTimeout(this.updateCountdown, 1000);
        }

        // console.log('using uuid: ', uuid);
        this.setState({ guid: uuid, live: live, timeToLive: timeToLive, votingEnded: votingEnded, timeToVoteEnd: timeToVoteEnd, nomsEnded: nomsEnded });

        let perRow = this.workOutNomineesPerRow();
        if (this.state.nomineesPerRow !== perRow) {
            this.setState({ nomineesPerRow: perRow });
        }

        if (!this.state.shortlistFetched) {
            this.fetchShortlist();
        } else
            if (this.state.regionNominees.length === 0 || this.state.nomineesPerRow !== perRow) {
                this.getNomineesForRegion(null, perRow);
            }

        window.addEventListener('resize', this.resizeHandler);
    }

    updateCountdown = () => {
        let time = Math.floor(Date.now() / 1000);

        let live = this.state.live;
        let timeToLive = 0;
        if (time > LIVE_TIME) {
            live = true;
        } else {
            live = false;
            timeToLive = LIVE_TIME - time;
        }

        let votingEnded = this.state.votingEnded;
        let timeToVoteEnd = 0;
        if (time > VOTE_END_TIME) {
            votingEnded = true;
        } else {
            votingEnded = false;
            timeToVoteEnd = VOTE_END_TIME - time;
        }

        let nomsEnded = false;
        if (time > NOMS_END_TIME) {
            nomsEnded = true;
        }

        this.setState({ live: live, timeToLive: timeToLive, votingEnded: votingEnded, timeToVoteEnd: timeToVoteEnd, nomsEnded: nomsEnded });
        if (!live || !votingEnded) {
            setTimeout(this.updateCountdown, 1000);
        }
    }

    resizeHandler = () => {
        let perRow = this.workOutNomineesPerRow();
        if (this.state.nomineesPerRow !== perRow) {
            // this.setState({nomineesPerRow: perRow});
            if (this.state.shortlistFetched) {
                this.getNomineesForRegion(null, perRow);
            }
        }
    }

    fetchShortlist = () => {
        ApiController.FetchRestaurants(this.parseRestaurantData);
    }

    parseRestaurantData = (data) => {
        // console.log('Restaurants: ', data);
        // let parsedRestaurants = [];

        // group our restaurants into regions
        let regionsRestaurants = {
        }
        for (let i = 0; i < AREA_IDS.length; i++) {
            regionsRestaurants[AREA_IDS[i]] = [];
        }
        for (let i = 0; i < data.response.length; i++) {
            let r = {
                id: data.response[i].restaurant_id,
                name: data.response[i].restaurant_name,
                area: data.response[i].region_id,
                image: /* data.response[i].region_id + '/' +  */data.response[i].restaurant_image,
            }
            // parsedRestaurants.push(r);
            regionsRestaurants[data.response[i].region_id].push(r);
        }

        // now concat those
        let parsedRestaurants = [].concat(regionsRestaurants.i, regionsRestaurants.l, regionsRestaurants.mid, regionsRestaurants.ne, regionsRestaurants.nw, regionsRestaurants.ni, regionsRestaurants.s, regionsRestaurants.se, regionsRestaurants.sw);

        this.setState({
            shortlistFetched: true,
            shortList: parsedRestaurants,
        });
        this.getNomineesForRegion(null, null, parsedRestaurants);
    }

    workOutNomineesPerRow = () => {
        let perRow = NOMINEES_PER_ROW;
        if (window.innerWidth < 576) {
            perRow = NOMINEES_PER_ROW_576;
        } else
            if (window.innerWidth < 840) {
                perRow = NOMINEES_PER_ROW_840;
            }
        return perRow;
    }

    getNomineesForRegion = (r = null, perRow = null, shortlist = null) => {
        r = r || this.state.currentArea;
        perRow = perRow || this.state.nomineesPerRow;
        shortlist = shortlist || this.state.shortList;

        // output csl
        /*let csv = '';
        for (let i = 0; i < shortlist.length; i++) {
            csv += '"' + (i + 1) + '",';
            csv += '"' + shortlist[i].name + '",';
            csv += '"' + shortlist[i].area + '",';
            csv += '"' + shortlist[i].image + '"\n';
        }
        console.log('----- SHORTLIST CSV -----');
        console.log(csv);
        console.log('----- SHORTLIST CSV END -----');*/

        // output restaurant names array php
        console.log('--- R_names PHP ---');
        let r_names_php = ('$r_names=[');
        for (let i = 0; i < shortlist.length; i++) {
            r_names_php += ('\n   \'' + shortlist[i].name + '\', ');
        }
        r_names_php += ('\n]');
        console.log(r_names_php);
        console.log('--- R_names PHP END ---');

        let nomineesArray = [];
        let nomineesRow = [];
        for (let i = 0; i < shortlist.length; i++) {
            if (r === 'all' || shortlist[i].area === r) {
                shortlist[i].i = i;
                if (!shortlist[i].id) {
                    shortlist[i].id = i + 1;
                }
                nomineesRow.push(shortlist[i]);
                if (i === shortlist.length - 1 || shortlist[i].area !== shortlist[i + 1].area) {
                    while (nomineesRow.length < perRow) {
                        nomineesRow.push({});
                    }
                }
                if (nomineesRow.length === perRow) {
                    nomineesArray.push(nomineesRow);
                    nomineesRow = [];
                }
            }
        }
        if (nomineesRow.length) {
            while (nomineesRow.length < perRow) {
                nomineesRow.push({});
            }
            nomineesArray.push(nomineesRow);
        }

        // console.log('Nominees: ', nomineesArray);

        this.setState({ regionNominees: nomineesArray, nomineesPerRow: perRow });
    }

    setRegion = (area, areaId) => {
        this.setState({ currentArea: area, currentAreaIndex: areaId });
        this.getNomineesForRegion(area);
    }

    showRegionDropdown = () => {
        this.setState({ showDropdown: true });
    }

    hideRegionDropdown = () => {
        this.setState({ showDropdown: false });
    }

    registerVote = (voteIndex) => {
        // disable voting for now
        // return;

        if (this.state.currentVotes.indexOf(voteIndex) === -1) {
            if (this.state.reacaptchaState !== RECAPTCHA_STATE.VERIFIED) {
                this.setState({lastVote: voteIndex, showRecaptcha: true});
            } else {
                let votes = this.state.currentVotes;
                votes.push(voteIndex);
                this.setState({ currentVotes: votes, lastVote: null });
                ApiController.PostVote(voteIndex, this.state.guid, this.state.recaptchaToken);
                // document.cookie = 'votes = ' + votes.join(',');
                if (this.storageAvailable()) {
                    localStorage.setItem('votes', votes.join(','));
                }

                this.setState({reacaptchaState: RECAPTCHA_STATE.LOADING, recaptchaToken: null, showRecaptcha: false});
            }
        }
    }

    captchaOnChange = (value) => {
        // console.log("Captcha value:", value);
        this.setState({reacaptchaState: value === null ? RECAPTCHA_STATE.READY : RECAPTCHA_STATE.VERIFIED, recaptchaToken: value});
        if (value !== null) {
            this.setState({showRecaptcha: false});
            if (this.state.lastVote !== null) {
                this.registerVote(this.state.lastVote);
            }
        }
    }

    render() {
        let rowsPerRegion = Math.ceil(10 / this.state.nomineesPerRow);
        let lastRegionForHeadings = '';
        let hoursToLive = 0;
        let minsToLive = 0;
        let secondsToLive = 0;
        if (this.state.timeToLive > 0) {
            hoursToLive = Math.floor(this.state.timeToLive / 3600);
            minsToLive = Math.floor(this.state.timeToLive % 3600 / 60);
            secondsToLive = Math.floor(this.state.timeToLive % 3600 % 60);
        }
        return (
            <>
                {this.state.showRecaptcha &&
                <div className={`recaptcha-holder${this.state.showRecaptcha ? ' recaptcha-on' : ''}`}>
                    <div className='grow'></div>
                    <h1>Before we submit your vote...</h1>
                    <p>Please complete the following Captcha to prove you are not a robot.</p>
                    <p>&nbsp;</p>
                    <ReCAPTCHA
                        sitekey="6Lcbx7AeAAAAAG_Me-BDJNdzs7tWXw_PINyUqG8Q"
                        onChange={this.captchaOnChange}
                    />
                    <div className='grow'></div>
                </div>
                }

                {!this.state.nomsEnded &&
                    <NominatePage></NominatePage>
                }

                {this.state.nomsEnded &&
                    <div className="split-page-holder-vote">
                        <div className="page-split-left-vote"><div className="left-content-holder-vote">

                            {this.state.votingEnded &&
                                <div className='small-screen-content-holder'>
                                    <div className="nom-header">
                                        <img className="uber-eats-logo-vote" src='./uber-assets/UE_Logo_Horizontal_RGB_web_GreenBG.svg' />
                                    </div>
                                    <h2>Uber Eats presents<br />The Restaurant of the Year Awards 2023</h2>
                                    <h1>Thanks for your votes.</h1>
                                    <p>Voting for the Uber Eats UK and Ireland Restaurant of the Year Awards is now closed. Stay tuned for the announcement of the finalists.</p>
                                    {/*<h2>Voting begins in<br/>{hoursToLive} Hours {minsToLive} Minutes {secondsToLive} Seconds<br />Come back later cast your vote!</h2>*/}
                                    {/*<h2>Nominations are now closed.</h2>
                        <h3>Regional Finalists will be announced on Monday 9th May where you can vote for your favourite.</h3>*/}
                                </div>
                            }

                            {!this.state.live && !this.state.votingEnded &&
                                <div className='small-screen-content-holder'>
                                    <div className="nom-header">
                                        <img className="uber-eats-logo-vote" src='./uber-assets/UE_Logo_Horizontal_RGB_web_GreenBG.svg' />
                                    </div>
                                    <h2>Uber Eats presents<br />The Restaurant of the Year Awards 2023</h2>
                                    <h1>Thanks for your nominations.</h1>
                                    <p>Nominations for the Uber Eats UK and Ireland Restaurant of the Year Awards are now closed. Stay tuned for our shortlist announcement and next round of voting in July.</p>
                                    {/*<h2>Voting begins in<br/>{hoursToLive} Hours {minsToLive} Minutes {secondsToLive} Seconds<br />Come back later cast your vote!</h2>*/}
                                    {/*<h2>Nominations are now closed.</h2>
                        <h3>Regional Finalists will be announced on Monday 9th May where you can vote for your favourite.</h3>*/}
                                </div>
                            }

                            {this.state.live && !this.state.votingEnded &&
                                <>
                                    <div className='small-screen-content-holder'>
                                        <div className="nom-header">
                                            <img className="uber-eats-logo-vote" src='./uber-assets/UE_Logo_Horizontal_RGB_web_GreenBG.svg' />
                                        </div>
                                        <h2>Uber Eats presents<br />The Restaurant of the Year Awards 2023</h2>
                                        <h1>Vote for your favourite<br />restaurant below.</h1>
                                        <p>Congratulations to everyone who was nominated for UK and Ireland's Restaurant of the Year 2023.{/*You can vote for your favourite below.*/}</p>
                                    </div>

                                    {this.state.shortlistFetched &&
                                        <>
                                            <hr />

                                            <div className='region-button-strip'>
                                                {
                                                    VOTE_AREAS_BUTTON_ORDER.map(
                                                        (item, index) => {
                                                            return (
                                                                <>
                                                                    <div className='region-button-holder' onClick={() => this.setRegion(item.areaId, index)}>
                                                                        <div className={'region-button v-button' + (this.state.currentArea === item.areaId ? ' v-active' : ' v-clickable')}>
                                                                            <div className='grow'></div>
                                                                            <div className='shrink'>
                                                                                <p>{item.label}</p>
                                                                            </div>
                                                                            <div className='grow'></div>
                                                                        </div>
                                                                    </div>
                                                                    {
                                                                        index < VOTE_AREAS_BUTTON_ORDER.length - 1 && <div className='region-button-spacer'></div>
                                                                    }
                                                                </>
                                                            );
                                                        }
                                                    )
                                                }
                                            </div>

                                            <div className='small-screen-content-holder'>

                                                <div className='region-drop-down' onClick={this.showRegionDropdown}>
                                                    <div className='grow'></div>
                                                    <div className='shrink'>
                                                        <div className='flex-columns'>
                                                            <div className='shrink'>
                                                                <p>{VOTE_AREAS_BUTTON_ORDER[this.state.currentAreaIndex].label}</p>
                                                            </div>
                                                            <div className='grow'></div>
                                                            <div className='shrink'>
                                                                <img className='drop-down-arrow' src='./uber-assets/downArrow.svg' />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='grow'></div>
                                                </div>

                                                {this.state.showDropdown &&
                                                    <div className='drop-down-open'>
                                                        <div className='drop-down-top'></div>
                                                        <div className='drop-down-contents'>
                                                            {
                                                                VOTE_AREAS_BUTTON_ORDER.map(
                                                                    (item, index) => {
                                                                        return (
                                                                            <>
                                                                                <div className='drop-down-option' onClick={() => { this.setRegion(item.areaId, index) }}>
                                                                                    <div className='shrink'>
                                                                                        <div className='drop-down-option-section'>
                                                                                            <div className='grow'></div>
                                                                                            <div className='shrink'>
                                                                                                <p>{item.label}</p>
                                                                                            </div>
                                                                                            <div className='grow'></div>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className='grow'></div>
                                                                                    <div className='shrink'>
                                                                                        <div className='drop-down-option-section'>
                                                                                            <div className='grow'></div>
                                                                                            <div className='shrink'>
                                                                                                {this.state.currentArea === item.areaId &&
                                                                                                    <img className='drop-down-check' src='./uber-assets/checkDark.svg' />
                                                                                                }
                                                                                            </div>
                                                                                            <div className='grow'></div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                {index < VOTE_AREAS_BUTTON_ORDER.length - 1 &&
                                                                                    <hr />
                                                                                }
                                                                            </>
                                                                        )
                                                                    }
                                                                )
                                                            }

                                                            <div className='drop-down-option-spacer'></div>

                                                            <div className='drop-down-option'>
                                                                <div className={'vote-button drop-down-button v-button v-clickable'} onClick={this.hideRegionDropdown}>
                                                                    <div className='grow'></div>
                                                                    <div className='shrink'>
                                                                        <p>View selected region</p>
                                                                    </div>
                                                                    <div className='grow'></div>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                }

                                                {this.state.currentArea !== 'all' &&
                                                    <h4>{VOTE_AREAS_BUTTON_ORDER[this.state.currentAreaIndex].label}</h4>
                                                }

                                                {
                                                    this.state.regionNominees.map(
                                                        (item, index) => {
                                                            // console.log('item, index, rowsPerRegion: ', item, index, rowsPerRegion, index % rowsPerRegion, index / rowsPerRegion);
                                                            let regionForHeadings = lastRegionForHeadings;
                                                            lastRegionForHeadings = item[0].area;
                                                            return (
                                                                <div key={'r_' + index}>
                                                                    {
                                                                        this.state.currentArea === 'all' && regionForHeadings !== lastRegionForHeadings &&
                                                                        <h4>{AREAS_OBJ[item[0].area]}</h4>
                                                                    }
                                                                    <div className='nominee-row' key={'nr_' + index}>
                                                                        {item.map(
                                                                            (item2, index2) => {
                                                                                return (
                                                                                    <>
                                                                                        <div className='nominee-holder' key={'nr_' + index + 'nh_' + index2}>
                                                                                            {item2.name &&
                                                                                                <>
                                                                                                    <div className='nominee-name'>
                                                                                                        <p dangerouslySetInnerHTML={{ __html: item2.name }}>{/*item2.name*/}</p>
                                                                                                    </div>
                                                                                                    <div className='nominee-pic-holder'>
                                                                                                        <div className='nominee-pic' style={{ backgroundImage: 'url(' + (item2.image != '' ? ('./uber-assets/restaurant_imgs/' + item2.area + '/' + item2.image) : './restaurantPlaceholder.jpg') + ')', backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' }}>
                                                                                                            {/*<img className='nominee-pic' src={'./uber-assets/restaurant_imgs/' + item2.image} />*/}
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <div className={'vote-button v-button' + (this.state.currentVotes/* .length > 0  */.indexOf(item2.id) >= 0 ? '' : ' v-active v-clickable')} onClick={/* this.state.currentVotes.length > 0 ? null :  */() => { this.registerVote(item2.id) }}>
                                                                                                        <div className='grow'></div>
                                                                                                        <div className='shrink'>
                                                                                                            <p>
                                                                                                                {this.state.currentVotes/* .length > 0 */.indexOf(item2.id) >= 0 && <img className='vote-check' src='./uber-assets/check.svg' />}
                                                                                                                {this.state.currentVotes/* .length > 0 */.indexOf(item2.id) >= 0 ? 'Thanks for voting' : 'Vote now'}
                                                                                                            </p>
                                                                                                        </div>
                                                                                                        <div className='grow'></div>
                                                                                                    </div>
                                                                                                </>
                                                                                            }
                                                                                        </div>
                                                                                        {
                                                                                            index2 < this.state.nomineesPerRow - 1 && <div className='nominee-spacer'></div>
                                                                                        }
                                                                                    </>
                                                                                )
                                                                            }
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            );
                                                        }
                                                    )
                                                }

                                            </div>
                                        </>
                                    }

                                </>
                            }

                            <div className='shrink'>
                                {/* <p className="form-label">This site is protected by reCAPTCHA and the Google Privacy Policy and Terms of Service apply.</p> */}
                                {/*<p>&nbsp;</p>*/}
                                <hr />
                                <div className='small-screen-content-holder'>
                                <p className="form-label">This site is protected by reCAPTCHA and the Google Privacy Policy and Terms of Service apply.</p>
                                    <p className="form-label">All submitted data will be treated in accordance with our <a href="https://uber.com/legal" target="_blank">Privacy Policy</a>.</p>
                                    <p className="form-label">Restaurant of the Year 2023 <a href="https://www.uber.com/en-GB/newsroom/uber-eats-restaurant-awards-terms-and-conditions/" target="_blank">Terms and Conditions</a>.</p>
                                    <p>&nbsp;</p>
                                    <p className="form-label">&#169; 2023 Uber Technologies Inc.</p>
                                </div>
                            </div>

                        </div></div>

                        <div className="page-split-right-vote">
                            {/*
                    <div>
                        <img className="win-badge" src="./uber-assets/winBadge.svg" />
                    </div>
                    */}
                        </div>
                    </div>
                }

            </>
        );
    }

}